import { ApiBase } from '@bymason/api-base';
import { productsCroppedImages } from '../../common/product-cropped-images';
import { products } from '../../common/products-temp-data';

class CmsProductCmsApi extends ApiBase {
  private static instance: CmsProductCmsApi;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns A ProductCmsApi instance
   */
  public static getInstance(): CmsProductCmsApi {
    if (!CmsProductCmsApi.instance) {
      CmsProductCmsApi.instance = new CmsProductCmsApi();
    }

    return CmsProductCmsApi.instance;
  }

  /**
   * Gets the product image provided the device family .
   * @returns either a CmsProductCarouselWidgetItem model or void
   */
  public async getProductImage(deviceFamily: string, _clientToken?: string) {
    //
    // TODO: Intergrate with strapi
    //
    const productImage = products.find((p) => p.productId === deviceFamily)?.imageUrl;
    const dataResponse = await Promise.resolve<string | undefined>(productImage);
    return dataResponse;
  }

  /**
   * Gets the cropped product image provided the device family. Used by buildsList & buildDetails views
   * @returns either a CmsProductCarouselWidgetItem model or void
   */
  public async getCroppedProductImage(deviceFamily: string, _clientToken?: string) {
    //
    // TODO: Intergrate with strapi
    //
    const productImage = productsCroppedImages.find((p) => p.productId === deviceFamily)?.imageUrl;
    const dataResponse = await Promise.resolve<string | undefined>(productImage);
    return dataResponse;
  }
}

export const productCmsApi = CmsProductCmsApi.getInstance();
